<form>
  <section>
    <h3 class="section-label bg-transparent text_normal font_normal" tabindex="0" #onboarding>
      Fill in the details for each of your Parata automation system (ATP, PASS, Max, etc…)
    </h3>
    <form [formGroup]='formGroup' #formDirective="ngForm" (submit)="submit()" class="adding_asset flex xl:flex-row lg:flex-row lt-lg:flex-row lt-lg:flex-wrap gt-md:justify-start gt-md:items-center gt-md:content-center xs:justify-start xs:items-end xs:content-end gt-xs:gap-4">
      <mat-form-field floatLabel="never" class="xl:basis-[24%] lg:basis-[24%] md:basis-[200px] sm:basis-[200px] xs:basis-full md:order-1 sm:order-1">
        <label for="FriendlyName">
          <app-icon icon="asterisk" size="10" aria-hidden="true"></app-icon>
          <span>Friendly Name</span>
        </label>
        <input matInput formControlName="FriendlyName" appNoHtmlTags id="FriendlyName" required maxlength="51" (blur)="FriendlyNameUnique($event.target.value, null)">
        <mat-error *ngIf="formGroup.get('FriendlyName').hasError('required')">Friendly Name required</mat-error>        
      </mat-form-field>
      <mat-form-field floatLabel="never" class="xl:basis-[24%] lg:basis-[24%] md:basis-[200px] sm:basis-[200px] xs:basis-full md:order-2 sm:order-2">
        <label for="MachineType">
          <app-icon icon="asterisk" size="10" aria-hidden="true"></app-icon>
          <span>System Type</span>
        </label>
        <mat-select formControlName="MachineType" id="MachineType" required>
          <mat-option *ngFor="let machType of ltMachineTypes;" [id]="machType?.name" [value]="machType?.machineTypeId" (click)="getInnerText(machType?.name)">
            {{ getMachineTypeDisplayName(machType) }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="formGroup.get('MachineType').hasError('required')">System Type required</mat-error>
      </mat-form-field>
      <mat-form-field floatLabel="never" class="serialnum xl:basis-[24%] lg:basis-[24%] md:basis-[200px] sm:basis-[200px] xs:basis-full sm:order-4">
        <label for="SerialNumber">
          <app-icon icon="asterisk" size="10" aria-hidden="true"></app-icon>
          <span>Serial Number</span>
          <custom-tooltip text="Packager Serial Number. For Pivot installations, this must exactly match the serial number in the Pivot Machines ID table."></custom-tooltip>
        </label>
        <input matInput formControlName="SerialNumber" appNoHtmlTags id="SerialNumber" maxlength="16" (blur)="SerialNoUniqueValidation($event.target.value, null)" required>
        <mat-error *ngIf="formGroup.get('SerialNumber').hasError('required')">Serial Number required</mat-error>
        <mat-error *ngIf="formGroup.get('SerialNumber').hasError('internalWhitespace')">Spaces are not allowed for Serial Number</mat-error>
        
      </mat-form-field>
      <mat-form-field floatLabel="center" class="scriptre xl:basis-[15%] lg:basis-[15%] md:basis-[200px] sm:basis-[18%] xs:basis-4/5 sm:order-5">
        <input matInput class="invisible" formControlName="ScriptRouting">
      </mat-form-field>
      <div class="cs_control_btn flex xl:basis-[13%] lg:basis-[13%] md:basis-[44%] sm:basis-[38%] xs:basis-full md:flex md:flex-row sm:flex sm:flex-row md:order-3 sm:order-3 justify-end items-center content-center">
        <a id="AdminClearAll" class="btn-link" (click)="reset()" (keydown.enter)="reset()" tabindex="0" aria-label="Clear all">Clear All ></a>
        <button class="btn-default btn-sm" type="submit" id="AddSystem" tabindex="0">
          Add
        </button>
      </div>
    </form>

    <form [formGroup]='updateFormGroup'>
      <ul formArrayName="systems" class="added_asset">
        <li *ngFor="let asset of assets$ | async; let index = index" class="flex xl:flex-row lg:flex-row lt-lg:flex-row lt-lg:flex-wrap gt-md:justify-start gt-md:items-center gt-md:content-center xs:justify-start xs:items-end xs:content-end gt-xs:gap-4">
            <ng-container [formGroupName]="index">
              <mat-form-field class="xl:basis-[24%] lg:basis-[24%] md:basis-[200px] sm:basis-[200px] xs:basis-full md:order-1 sm:order-1">
                  <label class="xl:hidden lg:hidden md:hidden sm:block xs:block">
                    <span>Friendly Name</span>
                  </label>
                  <input matInput formControlName="friendlyName" tabindex="0"  maxlength="51"  appNoHtmlTags (blur)="FriendlyNameUnique($event.target.value, asset)"> 
                  <mat-error *ngIf="SystemFriendlyNameValid(index)">Friendly Name required</mat-error>        

                </mat-form-field>
                <mat-form-field class="xl:basis-[24%] lg:basis-[24%] md:basis-[200px] sm:basis-[200px] xs:basis-full md:order-2 sm:order-2">
                  <label class="xl:hidden lg:hidden md:hidden sm:block xs:block">
                    <span>System Type</span>
                  </label>
                  <input [id]="asset?.name + '_SystemType'"  matInput value="{{getAssetMachineTypeDisplayName(asset)}}" disabled tabindex="0">
                </mat-form-field>
                <mat-form-field class="serialnum_v xl:basis-[24%] lg:basis-[24%] md:basis-[200px] sm:basis-[200px] xs:basis-full md:order-4 sm:order-4">
                  <label class="xl:hidden lg:hidden md:hidden sm:block xs:block">
                    <span>Serial Number</span>
                  </label>
                  <input formControlName="serialNo" matInput disabled tabindex="0">
                </mat-form-field>
                <div class="sre sre_v sm:flex sm:flex-col xs:flex xs:flex-col xl:basis-[15%] lg:basis-[15%] sm:basis-[24%] xs:basis-[65%] md:order-5 sm:order-5">
                </div>
                <div class="asset_controls flex flex-row justify-end items-center content-center xl:basis-[13%] lg:basis-[13%] md:basis-[44%] sm:basis-[38%] md:order-3 sm:order-3 xs:basis-full">
                  <button *ngIf="SystemEnabled(index)" [id]="asset?.name + '_Save'" class="btn-default btn-sm asset_control" type="button" tabindex="0" (click)="updateOrgAsset(asset, index)">
                    Save
                  </button>
                  <button *ngIf="SystemEnabled(index)" [id]="asset?.name + '_Clear'" class="btn-transparent btn_icon asset_control" type="button" tabindex="0" aria-label="clear" (click)="resetOrgAsset(asset, index)" (keypress.enter)="resetOrgAsset(asset, index)">
                    <span class="svgicon icon_clear"></span>
                  </button>
                  <button *ngIf="!SystemEnabled(index) && isAdmin" [id]="asset?.name + '_Edit'" class="btn-transparent btn_icon asset_control" type="button" tabindex="0" aria-label="edit" (click)="editOrgAsset(index)" (keypress.enter)="editOrgAsset(index)">
                    <span class="svgicon icon_edit"></span>
                  </button>
                  @if (userCanSubscribe) {
                    <div class="flex flex-row" style="justify-content:end;align-items:center;padding-right:2.5em;">
                      <div class="nonform-label">
                        <span>Receive Alerts</span>
                      </div>
                      @if (subscriptions.has(asset.assetId)) {
                        <input type="checkbox" (change)="onSubscriptionChange(asset, $event)" checked>
                      }
                      @else {
                        <input type="checkbox" (change)="onSubscriptionChange(asset, $event)">
                      }
                    </div>
                  }
                  <button [id]="asset?.name + '_Delete'" class="btn-transparent btn_icon asset_control" type="button" tabindex="0" aria-label="trash" (click)="deleteOrgAsset(asset)" (keypress.enter)="deleteOrgAsset(asset)">
                    <span class="svgicon icon_trash"></span>
                  </button>
                </div>
              </ng-container>
          </li>
      </ul>
    </form>  

  </section>

  <section class="text-right m-t-50 m-b-30 m-r-15">
  </section>
</form>
